import React, { useState, useEffect, useCallback, useRef } from 'react';
import { TabBar, useTabs } from '../TabManager';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import DocumentDetailModal from './DocumentDetailModal';
import DocumentControlModal from './DocumentControlModal';
import AccountingPattern from './AccountingPattern';
import DepositReadyModal from './DepositReadyModal';
import TreasuryDepositReadyModal from './TreasuryDepositReadyModal';
import ZemanatReadyModal from './ZemanatReadyModal';
import CreditReadyModal from './CreditReadyModal';
import AllocateReadyModal from './AllocateReadyModal';
import ReceiveReadyModal from './ReceiveReadyModal';
import ContractReadyModal from './ContractReadyModal';
import ContractorRequestReadyModal from './ContractorRequestReadyModal';
import HazinehReadyModal from './HazinehReadyModal';
import DepreciatoryReadyModal from './DepreciatoryReadyModal';
import HavalehReadyModal from './HavalehReadyModal';
import AccountingPrintDialog from './AccountingPrintDialog';
import GeneralReport from './GeneralReport';
import ContractorBlackList from '../../components/ContractorBlackList';
import { jsonOf, netErr } from '../../utils/http';
const toFa = n =>
  n === null || n === undefined ? '' :
  String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng = s =>
  String(s).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt = n => n ? Number(n).toLocaleString('fa-IR') : '•';
const curYear = () => toEng(new Date().toLocaleDateString('fa-IR').split('/')[0]);

const DOC_KINDS = [
  { val:0, label:'عادی' }, { val:1, label:'افتتاحیه' }, { val:2, label:'اختتامیه' },
];
const ACC_KINDS = [
  { val:0, label:'— انتخاب کنید —' }, { val:1, label:'هزینه ای' }, { val:2, label:'تملک' },
];

/* منوی ثبت خودکار اسناد */
const AUTO_MENU_ITEMS = [
  { key:'pattern', vb:'BTNPATTERN',      label:'الگو',                        icon:'🗂️', enabled:true  },
  { key:'deposit', vb:'BTNDEPOSITREADY',      label:'سپرده',                       icon:'💰', enabled:true  },
  { key:'treasury', vb:'BTNTREASURYDEPOSITREADY',      label:'سپرده اسناد خزانه',          icon:'🏦', enabled:true },
  { key:'zemanat', vb:'BTNZEMANATREADY',      label:'ضمانت‌نامه',                    icon:'📜', enabled:true },
  { key:'credit', vb:'BTNCREDITREADY',       label:'اعتبار',                      icon:'💳', enabled:true },
  { key:'allocate', vb:'BTNALLOCATEREADY',     label:'تخصیص',                       icon:'📊', enabled:true },
  { key:'receive', vb:'BTNRECEIVEREADY',      label:'دریافتی',                     icon:'📥', enabled:true },
  { key:'contract', vb:'BTNCONTRACT',     label:'قرارداد',                     icon:'📄', enabled:true },
  { key:'statement', vb:'BTNCONTRACTORREQUEST',   label:'صورت وضعیت',                  icon:'🧾', enabled:true },
  { key:'hazineh', vb:'BTNHAZINEHDOCUMENT',      label:'سند هزینه',                   icon:'💵', enabled:true  },
  { key:'depreciatory', vb:'BTNDEPRECIATORY', label:'استهلاک حفظ قدرت خرید',       icon:'📉', enabled:true  },
  { key:'havaleh', vb:'BTNHAVALEHREADY',      label:'تامین اعتبار',                icon:'✅', enabled:true  },
];

const EMPTY_FORM = {
  document_no:'', document_date:'', document_remark:'', remark:'',
  contract_id:0, contractor_code:0, contractor_name:'', contract_display:'',
  document_kind:0, accounting_kind:0, refrence_amount:'', havaleh:'',
  send_to_inout:false, is_closed:false,
};

const API = (path, opts={}) =>
  fetch(`/api/accounting${path}`, {
    headers:{ 'Content-Type':'application/json',
               Authorization:`Bearer ${localStorage.getItem('access')}` }, ...opts,
  }).then(jsonOf, netErr);

/* ── کامپوننت‌ها خارج از main ── */
const FInput = ({ label, name, value, onChange, readOnly, half, note }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex:half?'0 0 48%':1 }}>
    <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>{label}</label>
    <input name={name} value={value} onChange={onChange} readOnly={readOnly}
      style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
        fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none',
        direction:'rtl', textAlign:'right', width:'100%', boxSizing:'border-box',
        background:readOnly?'#f5f5f5':'#fff', color:readOnly?'#888':'#111',
        cursor:readOnly?'not-allowed':'text' }} />
    {note && <span style={{ fontSize:'11px', color:'#999' }}>{note}</span>}
  </div>
);

const FSelect = ({ label, name, value, onChange, opts, half, disabled }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex:half?'0 0 48%':1 }}>
    <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>{label}</label>
    <select name={name} value={value} onChange={onChange} disabled={disabled}
      style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
        fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none',
        background:disabled?'#f5f5f5':'#fff', color:disabled?'#888':'#111' }}>
      {opts.map(o=><option key={o.val} value={o.val}>{o.label}</option>)}
    </select>
  </div>
);

const FCheck = ({ label, name, checked, onChange, disabled }) => (
  <label style={{ display:'flex', alignItems:'center', gap:'6px', cursor:disabled?'not-allowed':'pointer',
    opacity:disabled?0.6:1,
    fontSize:'13px', userSelect:'none', padding:'6px 10px', borderRadius:'8px',
    background:checked?'#e8eaf6':'#f5f5f5',
    border:`1.5px solid ${checked?'#7986cb':'#e0e0e0'}`,
    color:checked?'#1a237e':'#888' }}>
    <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled}
      style={{ width:'15px', height:'15px', cursor:disabled?'not-allowed':'pointer' }} />
    {label}
  </label>
);

/* ── پاپ‌آپ لیست کامل قراردادها ── */
const ContractPopup = ({ onSelect, onClose }) => {
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page,    setPage]    = useState(1);
  const [sTotal,  setSTotal]  = useState(0);
  const [sMore,   setSMore]   = useState(false);

  const { widths, TH } = useColumnResize([
    40, 90, 80, 200, 160, 100, 110,
  ]);

  const {
    visibleRows, search, setSearch, hasMore,
    filteredCount, shownCount, LoadMoreButton, resetPagination,
  } = useTablePagination({
    allRows,
    serverTotal: sTotal,
    serverHasMore: sMore,
    searchFields: ['contract_no','contract_subject','contractor_name','national_code'],
  });

  const load = useCallback(async (p = 1, append = false) => {
    setLoading(true);
    const j = await API(`/documents/contract-search/?page=${p}`);
    setLoading(false);
    if (j.ok) {
      setAllRows(prev => append ? [...prev, ...j.data] : j.data);
      setSTotal(j.total || 0);
      setSMore(!!j.has_more);
      setPage(p);
    }
  }, []);

  useEffect(() => { load(1); }, [load]);

  const loadMore = () => load(page + 1, true);

  const numFmtL = n => n ? Number(n).toLocaleString('fa-IR') : '•';

  return (
    <div style={cp.overlay} onClick={onClose}>
      <div style={cp.modal} onClick={e=>e.stopPropagation()}>
        <div style={cp.hdr}>
          <span style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>📄 انتخاب قرارداد</span>
          <button onClick={onClose} style={cp.xBtn}>✕</button>
        </div>

        <div style={cp.body}>
          {/* جستجو */}
          <div style={{display:'flex',gap:'10px',alignItems:'flex-end',flexWrap:'wrap'}}>
            <div style={{flex:1}}>
              <input value={search} onChange={e=>setSearch(e.target.value)} autoFocus
                placeholder="جستجو: شماره / موضوع / پیمانکار / کدملی..."
                style={cp.inp} />
            </div>
            <span style={{fontSize:'11px',color:'#888'}}>
              {search
                ? `${toFa(shownCount)} نتیجه`
                : `${toFa(allRows.length)} از ${toFa(sTotal)} قرارداد`
              }
            </span>
          </div>

          {/* جدول */}
          <div style={{flex:1,overflow:'auto',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11px',tableLayout:'fixed'}}>
              <thead>
                <tr>
                  <TH idx={0}>ردیف</TH>
                  <TH idx={1}>شماره قرارداد</TH>
                  <TH idx={2}>تاریخ</TH>
                  <TH idx={3} right>موضوع</TH>
                  <TH idx={4} right>پیمانکار</TH>
                  <TH idx={5}>کد ملی</TH>
                  <TH idx={6} red>مبلغ قرارداد</TH>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((r,i)=>(
                  <tr key={r.contract_id}
                    style={{background:i%2===0?'#fff':'#fafafa',cursor:'pointer'}}
                    onClick={()=>onSelect(r)}
                    onMouseEnter={e=>e.currentTarget.style.background='#e0f2f1'}
                    onMouseLeave={e=>e.currentTarget.style.background=i%2===0?'#fff':'#fafafa'}>
                    <td style={cp.td}>{toFa(i+1)}</td>
                    <td style={{...cp.td,fontWeight:'700',color:'#1a237e'}}>{r.contract_no}</td>
                    <td style={{...cp.td,fontFamily:'monospace'}}>{r.contract_date}</td>
                    <td style={{...cp.td,textAlign:'right'}} title={r.contract_subject}>{r.contract_subject}</td>
                    <td style={{...cp.td,textAlign:'right',fontWeight:'600',color:'#00695c'}}>{r.contractor_name}</td>
                    <td style={{...cp.td,fontFamily:'monospace',fontSize:'10px'}}>{r.national_code||'—'}</td>
                    <td style={{...cp.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>
                      {r.contract_cost>0?numFmtL(r.contract_cost):'—'}
                    </td>
                  </tr>
                ))}
                {!loading && visibleRows.length===0 && (
                  <tr><td colSpan={7} style={{...cp.td,padding:'30px',color:'#999'}}>📭 قراردادی یافت نشد</td></tr>
                )}
              </tbody>
            </table>
          </div>

          {!search && <LoadMoreButton onClick={loadMore} loading={loading}/>}
        </div>
      </div>
    </div>
  );
};
const cp = {
  overlay: {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,
            display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:   {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'1100px',
            maxHeight:'90vh',display:'flex',flexDirection:'column',
            boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden'},
  hdr:     {display:'flex',justifyContent:'space-between',alignItems:'center',
            padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',
            borderRadius:'14px 14px 0 0',flexShrink:0},
  xBtn:    {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',
            color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',
            fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:    {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  inp:     {padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',
            fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
            direction:'rtl',width:'100%',boxSizing:'border-box'},
  td:      {padding:'5px 8px',fontSize:'11px',textAlign:'center',
            borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap',
            overflow:'hidden',textOverflow:'ellipsis'},
};


/* جستجوی قرارداد + پاپ‌آپ */
const ContractSearch = ({ value, contractDisplay, onSelect, onClear }) => {
  const [q, setQ]           = useState('');
  const [results, setResults]= useState([]);
  const [open, setOpen]     = useState(false);
  const [loading, setLoading]= useState(false);
  const [popup, setPopup]   = useState(false);
  const timer = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = e => { if(wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  /* با هر تایپ جستجو می‌شود و اگر فقط یک قرارداد پیدا شد خودش انتخاب و پیمانکار پر می‌شود.
     Enter اولین ردیف را انتخاب می‌کند. */
  const search = async (text) => {
    if (!text || !text.trim()) { setResults([]); setOpen(false); return; }
    setLoading(true);
    const j = await API(`/documents/contract-search/?q=${encodeURIComponent(text.trim())}`);
    setLoading(false);
    if (!j.ok) return;
    if (j.data.length === 1) { selectRef.current(j.data[0]); return; }
    setResults(j.data); setOpen(j.data.length > 0);
  };

  const handleChange = e => {
    const v = e.target.value;
    setQ(v);
    if (timer.current) clearTimeout(timer.current);
    if (!v) { onClear(); setOpen(false); return; }
    timer.current = setTimeout(() => search(v), 400);
  };

  const select = row => { setQ(''); setOpen(false); setPopup(false); onSelect(row); };
  const selectRef = useRef(select);
  selectRef.current = select;

  return (
    <div ref={wrapRef} style={{ display:'flex', flexDirection:'column', gap:'4px', flex:1 }}>
      <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>قرارداد</label>
      {value > 0 && (
        <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px',
          background:'#e8f5e9', border:'1px solid #a5d6a7', borderRadius:'6px', padding:'6px 10px' }}>
          <span style={{ fontSize:'12px', color:'#1b5e20', flex:1 }}>{contractDisplay}</span>
          <button onClick={onClear}
            style={{ background:'none', border:'none', color:'#b71c1c', cursor:'pointer', fontSize:'16px', padding:'0 4px' }}>✕</button>
        </div>
      )}
      <div style={{ position:'relative' }}>
        <input value={q} onChange={handleChange}
          onKeyDown={e => { if (e.key === 'Enter' && results.length) { e.preventDefault(); select(results[0]); } }}
          onDoubleClick={()=>setPopup(true)}
          placeholder="جستجو یا دابل‌کلیک برای لیست کامل..."
          style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
            fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none',
            direction:'rtl', width:'100%', boxSizing:'border-box' }} />
        {loading && <span style={{ position:'absolute', left:'10px', top:'9px', fontSize:'12px', color:'#999' }}>⏳</span>}
        {open && results.length > 0 && (
          <div style={{ position:'absolute', top:'100%', right:0, left:0, background:'#fff',
            border:'1px solid #e0e0e0', borderRadius:'8px', boxShadow:'0 4px 16px rgba(0,0,0,0.15)',
            zIndex:500, maxHeight:'250px', overflowY:'auto', marginTop:'2px' }}>
            {results.map(r => (
              <div key={r.contract_id} onClick={() => select(r)}
                style={{ padding:'8px 12px', cursor:'pointer', borderBottom:'1px solid #f5f5f5',
                  fontSize:'12px', direction:'rtl' }}
                onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                <div style={{ fontWeight:'700', color:'#1a237e' }}>
                  {r.contract_no} — {r.contract_date}
                </div>
                <div style={{ color:'#555', marginTop:'2px' }}>{r.contractor_name}</div>
                <div style={{ color:'#888', fontSize:'11px' }}>{r.contract_subject}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      {popup && <ContractPopup onSelect={select} onClose={()=>setPopup(false)} />}
    </div>
  );
};

export default function AccountingDocument({ user, onBack }) {
  const [year,        setYear]        = useState(curYear);
  const [data,        setData]        = useState([]);
  const [total,       setTotal]       = useState(0);
  const [page,        setPage]        = useState(1);
  const [hasMore,     setHasMore]     = useState(false);
  const [loading,     setLoading]     = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [selected,    setSelected]    = useState(null);
  const [blackList,   setBlackList]   = useState(null);   // پنجرهٔ Black List پیمانکار سند
  const [showPrint,   setShowPrint]   = useState(false);
  const [modal,       setModal]       = useState(null);
  const [openPwd,     setOpenPwd]     = useState('');   // رمز ذیحساب برای خروج از دائم
  // دیده‌شدن دکمه‌ها — /document-permissions/ (پیش‌فرض: پنهان تا پاسخ سرور برسد)
  const [dperm, setDperm] = useState({});
  // منوی «سند خودکار»: فقط گزینه‌هایی که دکمهٔ «آماده»ی فرم سند برایشان باز است (دیدن = دسترسی)
  const autoItems = AUTO_MENU_ITEMS.filter(it => !!(dperm.auto && dperm.auto[it.vb]));
  useEffect(() => {
    API('/document-permissions/').then(j => { if (j && j.ok) setDperm(j); }).catch(() => {});
  }, []);
  const [openErr,     setOpenErr]     = useState('');
  const [form,        setForm]        = useState(EMPTY_FORM);
  const [saving,      setSaving]      = useState(false);
  const [error,       setError]       = useState('');
  const [toast,       setToast]       = useState('');
  const [detailDoc,   setDetailDoc]   = useState(null);
  const [controlDoc,  setControlDoc]  = useState(null);
  const [autoMenuOpen,   setAutoMenuOpen]   = useState(false);
  const [showDepositReady, setShowDepositReady] = useState(false);
  const [showTreasuryDeposit, setShowTreasuryDeposit] = useState(false);
  const [showZemanatModal, setShowZemanatModal] = useState(false);
  const [showCreditModal, setShowCreditModal] = useState(false);
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [showReceiveModal, setShowReceiveModal] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [showStatementModal, setShowStatementModal] = useState(false);
  const [showHazinehModal, setShowHazinehModal] = useState(false);
  const [showDepreciatoryModal, setShowDepreciatoryModal] = useState(false);
  const [showHavalehModal, setShowHavalehModal] = useState(false);
  const [havalehWarn, setHavalehWarn] = useState('');
  const [search,      setSearch]      = useState('');
  const { openTab } = useTabs();
  const tbodyRef = useRef(null);

  const { widths: colW, TH } = useColumnResize([
    // حسابداری شماره تاریخ شرح اعتبارات حواله
       60,     55,   90,  200,    80,     70,    90,      130,     45,
    // بدهکار بستانکار مانده پیمانکار قرارداد مبلغ‌قرارداد
      130,    130,    90,   160,     200,     130,       110,    65,   40,    40,     100,  50,
  ]);

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  /* ── رنگ آمیزی اسناد با توجه به دریافت و پرداخت ──
     red = سند/آرتیکل ارسال نشده · skyblue = ارسال شده ولی چک/فیش صادر نشده ·
     rosybrown = مبلغ چک/فیش با مبلغ سند مغایرت دارد  (منطق در سرور: DocumentInOutColorsView) */
  const [colorize,    setColorize]    = useState(false);
  const [inoutColors, setInoutColors] = useState({});
  // رنگ‌ها با هر انتخاب سطر و فقط وقتی تیک خورده محاسبه و روی سطرها «گذاشته» می‌شوند؛
  // رنگ قبلی پاک نمی‌شود و برداشتن تیک هم رنگ‌ها را تا بارگذاری دوبارهٔ فهرست پاک نمی‌کند.
  useEffect(() => { setInoutColors({}); }, [data]);            // فهرست تازه = رنگ پیش‌فرض
  useEffect(() => {
    if (!colorize || !data.length) return;
    let alive = true;
    const ids = data.map(r => r.id).join(',');
    API(`/documents/inout-colors/?year=${year}&ids=${ids}`).then(j => {
      if (alive && j && j.ok) setInoutColors(prev => ({ ...prev, ...(j.data || {}) }));
    }).catch(() => {});
    return () => { alive = false; };
  }, [colorize, data, year, selected?.id]);

  /* راست‌کلیک روی فهرست: پیام دربارهٔ سطر جاری است، نه سطری که رویش کلیک شده. */
  const inoutMessage = () => {
    const r = selected;
    if (!r || !(r.send_able > 0)) return '';
    const c = inoutColors[String(r.id)];
    if (!r.send_to_inout && c === 'red') return 'سند به دریافت و پرداخت ارسال نشده است';
    if (c === 'red')       return 'همه اقلام سند به دریافت و پرداخت ارسال نشده است';
    if (c === 'rosybrown') return 'مبلغ سند با مبلغ فیش یا چک مغایرت دارد';
    if (c === 'skyblue')   return 'اقلام سند به دریافت و پرداخت ارسال شده اما هنوز فیش یا چک ثبت نشده است';
    return '';
  };

  const load = useCallback(async (y=year) => {
    if (!y || y.length!==4) return;
    setLoading(true); setError(''); setSearch(''); setPage(1);
    const j = await API(`/documents/?year=${y}&page=1`);
    setLoading(false);
    if (j.ok) { setData(j.data); setTotal(j.total); setHasMore(j.has_more); }
    else setError(j.msg);
  }, [year]);

  useEffect(()=>{ load(); },[]);// eslint-disable-line

  const loadMore = async () => {
    const next = page+1; setLoadingMore(true);
    const j = await API(`/documents/?year=${year}&page=${next}`);
    setLoadingMore(false);
    if (j.ok) { setData(d=>[...d,...j.data]); setHasMore(j.has_more); setPage(next); }
  };

  const handleYearChange = e => {
    const val = toEng(e.target.value).replace(/\D/g,'').slice(0,4);
    setYear(val);
    if (val.length===4) load(val);
  };

  const filtered = search.trim()
    ? data.filter(r => {
        const s = search.trim();
        const sE = toEng(s);
        return String(r.document_no).includes(sE)
          || r.document_date.includes(s)
          || r.document_remark.includes(s)
          || r.contractor_name.includes(s)
          || r.contract_no.includes(s)
          || r.contract_subject.includes(s);
      })
    : data;

  const handleFormChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f=>({ ...f, [name]: type==='checkbox'?checked:value }));
  };

  const checkHavaleh = async (val) => {
    const h = Number(toEng(String(val)));
    if (!h) { setHavalehWarn(''); return; }
    const excludeId = modal==='edit' ? (selected?.id||0) : 0;
    const j = await API(`/documents/havaleh-check/?year=${year}&havaleh=${h}&exclude_id=${excludeId}`);
    if (j.ok && j.duplicate) {
      setHavalehWarn(`⚠️ شماره اعتبارات ${toFa(h)} قبلاً در سند ${toFa(j.doc_no)} (${j.doc_date}) استفاده شده`);
    } else {
      setHavalehWarn('');
    }
  };

  const openNew = async () => {
    setError('');
    const j = await API(`/documents/next-no/?year=${year}`);
    setForm({
      ...EMPTY_FORM,
      document_no:    j.ok ? String(j.next_no) : '',
      document_date:  j.ok ? (j.last_date||'') : '',
      financial_year: year,
    });
    setModal('new');
  };

  const openEdit = () => {
    if (!selected) return;
    setForm({
      document_no:      String(selected.document_no),
      document_date:    selected.document_date,
      document_remark:  selected.document_remark,
      remark:           selected.remark,
      contract_id:      selected.contract_id,
      contractor_code:  selected.contractor_code||0,
      contractor_name:  selected.contractor_name,
      contract_display: selected.contract_display,
      document_kind:    selected.document_kind,
      accounting_kind:  selected.accounting_kind,
      refrence_amount:  String(selected.refrence_amount||''),
      havaleh:          String(selected.havaleh||''),
      send_to_inout:    !!selected.send_to_inout,
      is_closed:        !!selected.is_closed,
      financial_year:   year,
    });
    setError(''); setModal('edit');
  };

  const save = async () => {
    if (!form.document_date) { setError('تاریخ سند الزامی است'); return; }
    setSaving(true); setError('');
    const payload = {
      ...form,
      financial_year:  year,
      document_no:     Number(toEng(String(form.document_no)))||0,
      refrence_amount: Number(toEng(String(form.refrence_amount)))||0,
      havaleh:         Number(toEng(String(form.havaleh)))||0,
    };
    const j = modal==='new'
      ? await API('/documents/create/', {method:'POST', body:JSON.stringify(payload)})
      : await API(`/documents/${selected.id}/update/`, {method:'PUT', body:JSON.stringify(payload)});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  // رمز ذیحساب ⇒ IsClosed=0
  const doOpenDoc = async () => {
    if (!openPwd.trim() || !selected) return;
    setSaving(true); setOpenErr('');
    const j = await API(`/documents/${selected.id}/open/`, {method:'POST', body:JSON.stringify({password:openPwd})});
    setSaving(false); setOpenPwd('');
    if (j.ok) { setModal(null); showToast(j.msg); load(); }
    else setOpenErr(j.msg);
  };

  // قفل فیلدهای سند دائم در ویرایش
  const locked = modal==='edit' && !!form.is_closed;

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/documents/${selected.id}/delete/`, {method:'DELETE'});
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('سند حذف شد'); load(); }
    else { setError(j.msg); setModal('delete_blocked'); }
  };

  return (
    <div style={s.page}>
      {/* هدر */}
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}>
            <img src={require('../../assets/images/arjan.png')} alt="ارجان"
              style={{ width:'34px', height:'34px', borderRadius:'7px' }} />
          </div>
          <div>
            <div style={s.hTitle}>سند حسابداری</div>
            <div style={s.hSub}>تنظیم حساب — سامانه ارجان</div>
          </div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>

      <TabBar />

      <main style={s.main}>
        {/* ── نوار ابزار sticky ── */}
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {/* دیده‌شدن دکمه‌ها بر اساس زنجیرهٔ مجوز؛ «حذف» و «کنترل سند»
                برای سند دائم دیده نمی‌شوند. */}
            {dperm.can_new && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {dperm.can_edit && (
            <button onClick={openEdit} disabled={!selected}
              style={{ ...s.btnEdit, opacity:selected?1:0.4, cursor:selected?'pointer':'default' }}>
              ✎ ویرایش
            </button>)}
            {dperm.can_delete && !selected?.is_closed && (
            <button onClick={()=>{ if(!selected) return; setError(''); setModal('delete'); }}
              disabled={!selected}
              style={{ ...s.btnDel, opacity:selected?1:0.4, cursor:selected?'pointer':'default' }}>
              ✕ حذف
            </button>)}
            {dperm.can_items && (
            <button onClick={()=>{ if(selected) setDetailDoc(selected); }}
              disabled={!selected}
              style={{ ...s.btnItems, opacity:selected?1:0.4, cursor:selected?'pointer':'default' }}>
              📋 اقلام سند
            </button>)}
            {dperm.can_print && (
            <button onClick={()=>setShowPrint(true)} style={s.btnPrint}>
              🖨️ چاپ و گزارش
            </button>)}
            {dperm.can_all_report && (
            <button onClick={()=>openTab('accounting:general-report', 'گزارش کلی حسابداری', '📊',
                () => <GeneralReport user={user} onBack={onBack} year={year} />)}
              style={s.btnAllReport}>
              📊 گزارش کلی
            </button>)}
            {dperm.can_validate && !selected?.is_closed && (
            <button onClick={()=>{ if(!selected) return; setControlDoc(selected); }}
              disabled={!selected}
              title={!selected?'ابتدا یک سطر انتخاب کنید':''}
              style={{ ...s.btnControl, opacity:selected?1:0.4, cursor:selected?'pointer':'default' }}>
              🔍 کنترل سند
            </button>)}

            {/* سند خودکار */}
            {autoItems.length > 0 && <div style={{ position:'relative' }}>
              <button onClick={()=>setAutoMenuOpen(v=>!v)} style={s.btnAuto}>
                🧮 سند خودکار {autoMenuOpen ? '▲' : '▼'}
              </button>
              {autoMenuOpen && (
                <>
                  <div style={s.autoMenuOverlay} onClick={()=>setAutoMenuOpen(false)} />
                  <div style={s.autoMenu}>
                    <div style={s.autoMenuTitle}>ثبت خودکار اسناد بر اساس:</div>
                    {autoItems.map(it => (
                      <button key={it.key}
                        disabled={!it.enabled}
                        onClick={() => {
                          if (!it.enabled) return;
                          setAutoMenuOpen(false);
                          if (it.key === 'pattern') {
                            
                            // فرم مدیریت الگو باز می‌شود
                            openTab('accounting:pattern', 'الگوی ثبت اسناد', '📋',
                              () => <AccountingPattern user={user} onBack={onBack} />);
                          } else if (it.key === 'deposit') {
                            // سند خودکار، بدون انتخاب
                            setShowDepositReady(true);
                          } else if (it.key === 'treasury') {
                            setShowTreasuryDeposit(true);
                          } else if (it.key === 'zemanat') {
                            setShowZemanatModal(true);
                          } else if (it.key === 'credit') {
                            setShowCreditModal(true);
                          } else if (it.key === 'allocate') {
                            setShowAllocateModal(true);
                          } else if (it.key === 'receive') {
                            setShowReceiveModal(true);
                          } else if (it.key === 'contract') {
                            setShowContractModal(true);
                          } else if (it.key === 'statement') {
                            setShowStatementModal(true);
                          } else if (it.key === 'hazineh') {
                            setShowHazinehModal(true);
                          } else if (it.key === 'depreciatory') {
                            setShowDepreciatoryModal(true);
                          } else if (it.key === 'havaleh') {
                            setShowHavalehModal(true);
                          }
                        }}
                        style={{ ...s.autoMenuItem,
                          opacity: it.enabled ? 1 : 0.45,
                          cursor: it.enabled ? 'pointer' : 'not-allowed',
                          background: it.enabled ? '#fff' : '#f7f7f7' }}>
                        <span style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                          <span>{it.icon}</span><span>{it.label}</span>
                        </span>
                        {!it.enabled && <span style={s.autoMenuSoon}>به‌زودی</span>}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>}
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:'2px' }}>
            <label style={s.filterLabel}>سال مالی</label>
            <input value={toFa(year)} onChange={handleYearChange} maxLength={4}
              placeholder="۱۴۰۵"
              style={{ ...s.filterInput, width:'80px', textAlign:'right', direction:'rtl' }} />
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:'2px', flex:1, minWidth:'180px' }}>
            <label style={s.filterLabel}>جستجو</label>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="شماره / تاریخ / شرح / پیمانکار / قرارداد..."
              style={s.filterInput} />
          </div>

          {/* وضعیت ارسال سند انتخاب‌شده؛ فقط از پنجرهٔ «ویرایش» قابل تغییر است. */}
          <label style={{ ...s.sendChk, opacity: selected ? 1 : 0.55 }}
            title={selected ? 'برای تغییر، سند را ویرایش کنید' : 'یک سند انتخاب کنید'}>
            <input type="checkbox" checked={!!selected?.send_to_inout} readOnly disabled
              style={{ width:'15px', height:'15px', accentColor:'#1565c0', margin:0 }} />
            ارسال به دریافت و پرداخت
          </label>

          {/* «سنددائم»: کلیک روی سند دائم ⇒ پنل رمز ذیحساب ⇒ خروج از حالت دائم.
              سند غیردائم با کلیک تغییری نمی‌کند (دائم کردن از «کنترل سند»). */}
          <label style={{ ...s.sendChk, opacity: selected ? 1 : 0.55, cursor: selected?.is_closed ? 'pointer' : 'default' }}
            title={selected?.is_closed ? 'برای خارج کردن سند از حالت دائم کلیک کنید (رمز ذیحساب)' : 'سند دائم نیست'}
            onClick={e => { e.preventDefault(); if (selected?.is_closed) { setOpenPwd(''); setOpenErr(''); setModal('open_doc'); } }}>
            <input type="checkbox" checked={!!selected?.is_closed} readOnly
              style={{ width:'15px', height:'15px', accentColor:'#e65100', margin:0, pointerEvents:'none' }} />
            سنددائم
          </label>

          {/* رنگ آمیزی اسناد */}
          <label style={{ ...s.sendChk, background:'#fff8e1', borderColor:'#ffe082', color:'#5d4037',
                          cursor:'pointer' }}
            title="سند ارسال‌نشده: قرمز · چک/فیش صادر نشده: آبی · مغایرت مبلغ: قهوه‌ای — راست‌کلیک روی سطر برای توضیح">
            <input type="checkbox" checked={colorize} onChange={e=>setColorize(e.target.checked)}
              style={{ width:'15px', height:'15px', margin:0, cursor:'pointer' }} />
            رنگ آمیزی اسناد با توجه به دریافت و پرداخت
          </label>

          <div style={s.countBadge}>
            {total>0 ? `${toFa(filtered.length)} از ${toFa(total)}` : toFa(filtered.length)} رکورد
          </div>

          <button onClick={()=>load()} disabled={loading} style={s.btnRefresh}>
            {loading?'⏳':'↺'}
          </button>
        </div>

        {error && !modal && <div style={s.errBox}>⚠️ {error}</div>}

        {/* ── جدول با sticky header ── */}
        <div style={s.tableWrap}>
          <table style={{...s.table, tableLayout:'fixed'}}>
            <thead style={{ position:'sticky', top:0, zIndex:10 }}>
              <tr>
                <TH idx={0}>حسابداری</TH>
                <TH idx={1}>شماره</TH>
                <TH idx={2}>تاریخ</TH>
                <TH idx={3} right>شرح</TH>
                <TH idx={4}>شماره اعتبارات</TH>
                <TH idx={5}>شماره حواله</TH>
                <TH idx={6}>تاریخ حواله</TH>
                <TH idx={7} right>صورت وضعیت</TH>
                <TH idx={8}>اقلام</TH>
                <TH idx={9} red>جمع بدهکار</TH>
                <TH idx={10} green>جمع بستانکار</TH>
                <TH idx={11} gold>مانده</TH>
                <TH idx={12} right>پیمانکار</TH>
                <TH idx={13} right>قرارداد</TH>
                <TH idx={14}>مبلغ قرارداد</TH>
                <TH idx={15}>مبلغ مرجع</TH>
                <TH idx={16}>وضعیت سند</TH>
                <TH idx={17}>قابل ارسال</TH>
                <TH idx={18}>ارسال شده</TH>
                <TH idx={19} right>توضیح</TH>
                <TH idx={20}>نوع سند</TH>
              </tr>
            </thead>
            <tbody ref={tbodyRef}>
              {filtered.map((r,i) => {
                const sel = selected?.id===r.id;
                const ioc = inoutColors[String(r.id)] || '';   // red | skyblue | rosybrown
                const bg  = sel?'#1a2f50':ioc?ioc:r.is_closed?'#fff3e0':i%2===0?'#fff':'#fafafa';
                const tc  = sel?'#fff':'#111';
                return (
                  <tr key={r.id}
                    style={{ background:bg, cursor:'pointer', transition:'background 0.1s' }}
                    onClick={()=>setSelected(sel?null:r)}
                    onContextMenu={e=>{
                      const m = inoutMessage();
                      if (!m) return;
                      e.preventDefault(); showToast(m);
                    }}
                    onDoubleClick={()=>setDetailDoc(r)}
                    onMouseEnter={e=>{ if(!sel) e.currentTarget.style.background='#e8f0fe'; }}
                    onMouseLeave={e=>{ if(!sel) e.currentTarget.style.background=bg; }}>
                    {/* حسابداری */}
                    <td style={{ ...s.td, fontSize:'11px', color:tc }}>
                      {r.accounting_kind===1?'هزینه ای':r.accounting_kind===2?'تملک':'—'}
                    </td>
                    {/* شماره */}
                    <td style={{ ...s.td, fontWeight:'700', color:sel?'#C8A84B':'#1a237e' }}>
                      {toFa(r.document_no)}
                    </td>
                    {/* تاریخ */}
                    <td style={{ ...s.td, fontFamily:'monospace', fontSize:'11px', color:tc }}>
                      {r.document_date}
                    </td>
                    {/* شرح */}
                    <td style={{ ...s.td, textAlign:'right', fontSize:'12px', color:tc }}
                      title={r.document_remark}>
                      {r.document_remark}
                    </td>
                    {/* شماره اعتبارات */}
                    <td style={{ ...s.td, color:tc }}>{r.havaleh||'—'}</td>
                    {/* شماره حواله */}
                    <td style={{ ...s.td, fontSize:'11px', color:tc }}>{r.havaleh_request_no||'—'}</td>
                    {/* تاریخ حواله */}
                    <td style={{ ...s.td, fontFamily:'monospace', fontSize:'11px', color:tc }}>
                      {r.havaleh_request_date||'—'}
                    </td>
                    {/* صورت وضعیت */}
                    <td style={{ ...s.td, textAlign:'right', fontSize:'11px', color:tc }}
                      title={r.contractor_statement}>
                      {r.contractor_statement||'—'}
                    </td>
                    {/* اقلام */}
                    <td style={{ ...s.td, color:tc }}>{toFa(r.item_count)||'•'}</td>
                    {/* جمع بدهکار */}
                    <td style={{ ...s.td, textAlign:'left', fontFamily:'monospace', fontWeight:'700',
                      color:sel?'#ef9a9a':r.sum_debit>0?'#b71c1c':'#ccc', paddingLeft:'8px' }}>
                      {r.sum_debit>0?numFmt(r.sum_debit):'•'}
                    </td>
                    {/* جمع بستانکار */}
                    <td style={{ ...s.td, textAlign:'left', fontFamily:'monospace', fontWeight:'700',
                      color:sel?'#a5d6a7':r.sum_credit>0?'#1b5e20':'#ccc', paddingLeft:'8px' }}>
                      {r.sum_credit>0?numFmt(r.sum_credit):'•'}
                    </td>
                    {/* مانده */}
                    <td style={{ ...s.td, fontWeight:'700',
                      color:sel?'#C8A84B':r.remain>0?'#e65100':'#999' }}>
                      {r.remain>0?numFmt(r.remain):'—'}
                    </td>
                    {/* پیمانکار */}
                    <td style={{ ...s.td, textAlign:'right', fontSize:'12px',
                      color:sel?'#C8A84B':'#1a237e', fontWeight:'600' }}>
                      {r.contractor_name||'—'}
                    </td>
                    {/* قرارداد */}
                    <td style={{ ...s.td, textAlign:'right', fontSize:'11px', color:sel?'rgba(255,255,255,0.8)':'#555' }}
                      title={r.contract_display}>
                      {r.contract_display||'—'}
                    </td>
                    {/* مبلغ قرارداد */}
                    <td style={{ ...s.td, textAlign:'left', fontFamily:'monospace', fontSize:'11px',
                      color:sel?'#ffcc80':r.contract_cost>0?'#424242':'#ccc', paddingLeft:'8px' }}>
                      {r.contract_cost>0?numFmt(r.contract_cost):'•'}
                    </td>
                    {/* مبلغ مرجع */}
                    <td style={{ ...s.td, textAlign:'left', fontFamily:'monospace', fontSize:'11px',
                      color:sel?'#fff':r.refrence_amount>0?'#37474f':'#ccc', paddingLeft:'8px' }}>
                      {r.refrence_amount>0?numFmt(r.refrence_amount):'•'}
                    </td>
                    {/* وضعیت سند */}
                    <td style={{ ...s.td }}>
                      {r.is_closed
                        ? <span style={{ background:'#fff3e0', color:'#e65100',
                            padding:'2px 5px', borderRadius:'4px', fontSize:'10px', fontWeight:'700' }}>دائم</span>
                        : <span style={{ color:'#ccc', fontSize:'11px' }}>—</span>}
                    </td>
                    {/* قابل ارسال = Acc1+Acc0 */}
                    <td style={{ ...s.td, color:r.send_able>0?(sel?'#81c784':'#1b5e20'):'#ccc', fontWeight:r.send_able>0?'700':'400' }}>
                      {r.send_able>0?toFa(r.send_able):'•'}
                    </td>
                    {/* ارسال شده = Acc1 (AccountCode>0) */}
                    <td style={{ ...s.td, color:r.sent>0?(sel?'#C8A84B':'#1976d2'):'#ccc', fontWeight:r.sent>0?'700':'400' }}>
                      {r.sent>0?toFa(r.sent):'•'}
                    </td>
                    {/* توضیح */}
                    <td style={{ ...s.td, textAlign:'right', fontSize:'11px',
                      color:sel?'rgba(255,255,255,0.7)':'#555' }}
                      title={r.remark}>
                      {r.remark||'—'}
                    </td>
                    {/* نوع سند */}
                    <td style={{ ...s.td, fontSize:'11px', color:tc }}>{r.document_kind_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!loading && data.length===0 && (
            <div style={s.empty}>📭 سندی برای سال {toFa(year)} یافت نشد</div>
          )}
        </div>

        {((hasMore && !search) || selected?.black_list) && (
          <div style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr', alignItems:'center',
                        gap:'12px', padding:'14px', direction:'rtl' }}>
            {/* ستون ۱ (راست): اخطار Black List — چسبیده به لبهٔ راست
                ستون ۲ (وسط): دکمهٔ ۲۰۰ سند بعدی — جایش ثابت می‌ماند */}
            <div style={{ gridColumn:1, justifySelf:'start' }}>
            {selected?.black_list && (
            <button onClick={()=>setBlackList({ code: selected.contractor_code, name: selected.contractor_name })}
              title="مشاهدهٔ محدودیت‌های پیمانکار"
              style={{ ...s.btnControl, background:'linear-gradient(135deg,#7f0000,#c62828)' }}>
              ⛔ اخطار: این پیمانکار در Black List  قرار دارد
            </button>)}
            </div>
            <div style={{ gridColumn:2 }}>
            {hasMore && !search && (
            <button onClick={loadMore} disabled={loadingMore} style={{
              padding:'9px 36px',
              background:loadingMore?'#ccc':'linear-gradient(135deg,#1a2f50,#1a237e)',
              color:'#fff', border:'none', borderRadius:'8px',
              cursor:loadingMore?'default':'pointer',
              fontFamily:'inherit', fontSize:'13px', fontWeight:'700',
            }}>
              {loadingMore?'⏳ در حال بارگذاری...'
                :`▼ ۲۰۰ سند بعدی (${toFa(total-data.length)} باقی‌مانده)`}
            </button>)}
            </div>
          </div>
        )}
      </main>

      {/* ═══ پاپ‌آپ جدید / ویرایش ═══ */}
      {(modal==='new'||modal==='edit') && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={s.modal} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}>
              <div style={s.mTitle}>
                {modal==='new'?'＋ سند جدید':`✎ ویرایش سند ${toFa(form.document_no)}`}
              </div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={s.mBody}>
              {error && <div style={s.errBox}>⚠️ {error}</div>}
              {locked && (
                <div style={{ ...s.errBox, background:'#fff3e0', color:'#e65100', borderColor:'#ffcc80' }}>
                  🔒 این سند دائم است؛ فقط «توضیح» قابل تغییر است.
                </div>
              )}

              {/* ردیف ۱: شماره / تاریخ */}
              <div style={s.row}>
                <FInput label="شماره سند" name="document_no"
                  value={toFa(form.document_no)} onChange={handleFormChange} half readOnly={locked} />
                <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex:'0 0 48%' }}>
                  <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>تاریخ سند *</label>
                  <JalaliDatePicker value={form.document_date} disabled={locked}
                    onChange={v=>setForm(f=>({...f,document_date:v}))}
                    placeholder="انتخاب تاریخ" />
                </div>
              </div>

              {/* ردیف ۲: نوع سند / نوع حسابداری */}
              <div style={s.row}>
                <FSelect label="نوع سند" name="document_kind" value={form.document_kind}
                  onChange={handleFormChange} opts={DOC_KINDS} half disabled={locked} />
                <FSelect label="نوع حسابداری" name="accounting_kind" value={form.accounting_kind}
                  onChange={handleFormChange} opts={ACC_KINDS} half disabled={locked} />
              </div>

              {/* ردیف ۳: شرح */}
              <div style={{ display:'flex', flexDirection:'column', gap:'4px', marginBottom:'12px' }}>
                <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>شرح</label>
                <textarea name="document_remark" value={form.document_remark}
                  onChange={handleFormChange} rows={2} readOnly={locked}
                  style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
                    fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                    outline:'none', resize:'vertical', direction:'rtl',
                    background:locked?'#f5f5f5':'#fff', color:locked?'#888':'#111' }} />
              </div>

              <div style={s.divider} />

              {/* ردیف ۴: جستجوی قرارداد */}
              <div style={{ marginBottom:'12px', ...(locked ? { pointerEvents:'none', opacity:0.6 } : {}) }}>
                <ContractSearch
                  value={form.contract_id}
                  contractDisplay={form.contract_display || form.contractor_name}
                  onSelect={row => setForm(f=>({
                    ...f,
                    contract_id:      row.contract_id,
                    contractor_code:  row.contractor_code,
                    contractor_name:  row.contractor_name,
                    contract_display: row.display,
                  }))}
                  onClear={() => setForm(f=>({
                    ...f,
                    contract_id:0, contractor_code:0,
                    contractor_name:'', contract_display:'',
                  }))}
                />
              </div>

              {/* پیمانکار — از قرارداد پر می‌شه */}
              <div style={{ marginBottom:'12px' }}>
                <FInput label="پیمانکار (از قرارداد)" name="contractor_name"
                  value={form.contractor_name} onChange={()=>{}} readOnly />
              </div>

              <div style={s.divider} />

              {/* ردیف ۵: شماره اعتبارات / مبلغ مرجع */}
              <div style={s.row}>
                <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex:'0 0 48%' }}>
                  <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>شماره اعتبارات</label>
                  <input name="havaleh" value={toFa(form.havaleh)} readOnly={locked}
                    onChange={handleFormChange}
                    onBlur={e => checkHavaleh(e.target.value)}
                    style={{ padding:'8px 12px', border:`1.5px solid ${havalehWarn?'#e65100':'#e0e0e0'}`,
                      borderRadius:'8px', fontSize:'13px',
                      fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                      outline:'none', direction:'rtl', textAlign:'right',
                      width:'100%', boxSizing:'border-box' }} />
                  {havalehWarn && <span style={{ fontSize:'11px', color:'#e65100', fontWeight:'600' }}>{havalehWarn}</span>}
                </div>
                <FInput label="مبلغ مرجع" name="refrence_amount"
                  value={toFa(form.refrence_amount)} onChange={handleFormChange} half readOnly={locked} />
              </div>

              {/* ردیف ۶: توضیح */}
              <div style={{ display:'flex', flexDirection:'column', gap:'4px', marginBottom:'12px' }}>
                <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>توضیح</label>
                <textarea name="remark" value={form.remark} onChange={handleFormChange}
                  rows={2} style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
                    fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                    outline:'none', resize:'vertical', direction:'rtl' }} />
              </div>

              <div style={s.divider} />

              {/* چک‌باکس‌ها */}
              <div style={{ display:'flex', gap:'12px', flexWrap:'wrap' }}>
                {/* «سنددائم» در جدید/ویرایش همیشه غیرفعال است
                    (دائم کردن فقط از «کنترل سند»، باز کردن فقط با رمز ذیحساب از صفحهٔ اصلی) و
                    در سند دائم، «ارسال به دریافت و پرداخت» هم قفل است. */}
                <FCheck label="ارسال به دریافت و پرداخت" name="send_to_inout"
                  checked={!!form.send_to_inout} onChange={handleFormChange} disabled={locked} />
                <FCheck label="سنددائم" name="is_closed"
                  checked={!!form.is_closed} onChange={()=>{}} disabled />
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>{setModal(null);setError('');}} style={s.btnCancel}>انصراف</button>
{dperm.can_ok &&               <button onClick={save} disabled={saving} style={s.btnSave}>
                {saving?'⏳ در حال ذخیره...':'💾 ذخیره'}
              </button>}
            </div>
          </div>
        </div>
      )}

      {/* ═══ پاپ‌آپ حذف ═══ */}
      {modal==='delete' && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{ ...s.modal, maxWidth:'460px' }} onClick={e=>e.stopPropagation()}>
            <div style={{ ...s.mHeader, background:'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={{ ...s.mBody, textAlign:'center', padding:'28px' }}>
              <div style={{ fontSize:'36px', marginBottom:'12px' }}>🗑️</div>
              <div style={{ background:'#fff3f3', border:'1px solid #ffcdd2', borderRadius:'8px',
                padding:'12px', fontWeight:'700', color:'#b71c1c' }}>
                سند شماره {toFa(selected?.document_no)} — {selected?.document_date}
                <br/><span style={{ fontSize:'12px', fontWeight:'400' }}>{selected?.document_remark}</span>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>خیر، انصراف</button>
              <button onClick={doDelete} disabled={saving}
                style={{ ...s.btnSave, background:'#b71c1c' }}>
                {saving?'⏳...':'بله، حذف شود'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modal==='open_doc' && selected && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{ ...s.modal, maxWidth:'400px' }} onClick={e=>e.stopPropagation()}>
            <div style={{ ...s.mHeader, background:'linear-gradient(135deg,#e65100,#f57c00)' }}>
              <div style={s.mTitle}>🔓 خارج کردن سند {toFa(selected.document_no)} از حالت دائم</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={{ ...s.mBody, padding:'22px' }}>
              {openErr && <div style={s.errBox}>⚠️ {openErr}</div>}
              <label style={{ fontSize:'12px', fontWeight:'600', color:'#555' }}>رمز ذیحساب</label>
              <input type="password" value={openPwd} autoFocus autoComplete="off"
                onChange={e=>setOpenPwd(e.target.value)}
                onKeyDown={e=>{ if (e.key==='Enter') doOpenDoc(); }}
                style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px', width:'100%',
                  boxSizing:'border-box', fontSize:'13px', fontFamily:'inherit', direction:'ltr', marginTop:'4px' }} />
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              <button onClick={doOpenDoc} disabled={saving || !openPwd.trim()} style={s.btnSave}>
                {saving ? '⏳' : 'تایید'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modal==='delete_blocked' && (
        <div style={s.overlay} onClick={()=>{setModal(null);setError('');}}>
          <div style={{ ...s.modal, maxWidth:'420px' }} onClick={e=>e.stopPropagation()}>
            <div style={{ ...s.mHeader, background:'linear-gradient(135deg,#e65100,#f57c00)' }}>
              <div style={s.mTitle}>🚫 عدم امکان حذف</div>
              <button onClick={()=>{setModal(null);setError('');}} style={s.closeBtn}>✕</button>
            </div>
            <div style={{ ...s.mBody, textAlign:'center', padding:'28px' }}>
              <div style={{ fontSize:'14px', color:'#1a2f50', fontWeight:'700' }}>{error}</div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>{setModal(null);setError('');}} style={s.btnSave}>باشه</button>
            </div>
          </div>
        </div>
      )}

      {detailDoc && (
        <DocumentDetailModal
          doc={detailDoc}
          year={year}
          onClose={()=>setDetailDoc(null)}
        />
      )}
      {blackList && (
        <ContractorBlackList contractorCode={blackList.code} contractorName={blackList.name}
          onClose={()=>{ setBlackList(null); }}/>
      )}
      {toast && <div style={s.toast}>{toast}</div>}

      {showDepositReady && (
        <DepositReadyModal year={year} onClose={()=>setShowDepositReady(false)} onAdded={()=>load()} />
      )}

      {showTreasuryDeposit && (
        <TreasuryDepositReadyModal year={year} onClose={()=>setShowTreasuryDeposit(false)} onAdded={()=>load()} />
      )}

      {showZemanatModal && (
        <ZemanatReadyModal year={year} onClose={()=>setShowZemanatModal(false)} onAdded={()=>load()} />
      )}
      {showCreditModal && (
        <CreditReadyModal year={year} onClose={()=>setShowCreditModal(false)} onAdded={()=>load()} />
      )}
      {showAllocateModal && (
        <AllocateReadyModal year={year} onClose={()=>setShowAllocateModal(false)} onAdded={()=>load()} />
        )}
      {showReceiveModal && (
       <ReceiveReadyModal year={year} onClose={()=>setShowReceiveModal(false)} onAdded={()=>load()} />
        )}
      {showContractModal && (
        <ContractReadyModal year={year} onClose={()=>setShowContractModal(false)} onAdded={()=>load()} />
      )}    
      {showStatementModal && (
        <ContractorRequestReadyModal year={year} onClose={()=>setShowStatementModal(false)} onAdded={()=>load()} />
      )}
      {showHazinehModal && (
        <HazinehReadyModal year={year} onClose={()=>setShowHazinehModal(false)} onAdded={()=>load()} />
      )}
      {showDepreciatoryModal && (
        <DepreciatoryReadyModal year={year} onClose={()=>setShowDepreciatoryModal(false)} onAdded={()=>load()} />
      )}
      {showHavalehModal && (
        <HavalehReadyModal year={year} onClose={()=>setShowHavalehModal(false)} onAdded={()=>load()} />
      )}
      {controlDoc && (
        <DocumentControlModal
          doc={controlDoc}
          year={year}
          onClose={()=>setControlDoc(null)}
          onClosedDoc={()=>{ setControlDoc(null); showToast('سند دائمی شد'); load(); }}
        />
      )}
      {showPrint && (
        <AccountingPrintDialog
          year={year}
          selected={selected}
          onClose={()=>setShowPrint(false)}
        />
      )}
    </div>
  );
}

const s = {
  page:     { height:'100vh', overflow:'hidden', background:'#f0f2f7', fontFamily:"'Vazirmatn',Tahoma,sans-serif", direction:'rtl',
              display:'flex', flexDirection:'column' },
  header:   { background:'linear-gradient(135deg,#0a1628,#1a2f50)', padding:'10px 24px',
              display:'flex', justifyContent:'space-between', alignItems:'center',
              boxShadow:'0 2px 16px rgba(0,0,0,0.3)', flexShrink:0 },
  hLeft:    { display:'flex', alignItems:'center', gap:'12px' },
  backBtn:  { padding:'6px 14px', background:'rgba(255,255,255,0.12)', color:'#fff',
              border:'1px solid rgba(255,255,255,0.25)', borderRadius:'7px',
              cursor:'pointer', fontFamily:'inherit', fontSize:'13px' },
  hLogo:    { width:'40px', height:'40px', background:'rgba(200,168,75,0.12)',
              border:'1px solid rgba(200,168,75,0.3)', borderRadius:'9px',
              display:'flex', alignItems:'center', justifyContent:'center' },
  hTitle:   { fontSize:'15px', fontWeight:'700', color:'#fff' },
  hSub:     { fontSize:'11px', color:'rgba(255,255,255,0.55)' },
  userName: { fontSize:'13px', color:'rgba(255,255,255,0.85)' },
  main:     { padding:'8px 20px', flex:1, display:'flex', flexDirection:'column', overflow:'hidden', minHeight:0 },

  toolbar:     { display:'flex', alignItems:'flex-end', gap:'10px', background:'#fff',
                 padding:'10px 16px', borderRadius:'12px',
                 boxShadow:'0 2px 8px rgba(0,0,0,0.1)', marginBottom:'8px',
                 flexWrap:'wrap', flexShrink:0 },
  toolBtns:    { display:'flex', gap:'7px' },
  sendChk:     { display:'flex', alignItems:'center', gap:'6px', alignSelf:'flex-end',
                 padding:'7px 12px', background:'#e3f2fd', border:'1px solid #90caf9',
                 borderRadius:'8px', fontSize:'12.5px', fontWeight:'700', color:'#0d47a1',
                 whiteSpace:'nowrap', cursor:'default' },
  filterLabel: { fontSize:'11px', fontWeight:'600', color:'#555' },
  filterInput: { padding:'7px 11px', border:'1.5px solid #e0e0e0', borderRadius:'8px',
                 fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif",
                 outline:'none', direction:'rtl', textAlign:'right' },
  btnNew:    { padding:'8px 18px', background:'linear-gradient(135deg,#1b5e20,#2e7d32)',
               color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnEdit:   { padding:'8px 18px', background:'linear-gradient(135deg,#1a237e,#283593)',
               color:'#fff', border:'none', borderRadius:'8px',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnDel:    { padding:'8px 18px', background:'linear-gradient(135deg,#b71c1c,#c62828)',
               color:'#fff', border:'none', borderRadius:'8px',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnClosing:{ padding:'8px 18px', background:'linear-gradient(135deg,#4a148c,#6a1b9a)',
               color:'#fff', border:'none', borderRadius:'8px',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700', cursor:'pointer' },
  btnControl:{ padding:'8px 18px', background:'linear-gradient(135deg,#004d40,#00695c)',
               color:'#fff', border:'none', borderRadius:'8px',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnItems:  { padding:'8px 18px', background:'linear-gradient(135deg,#4a148c,#6a1b9a)',
               color:'#fff', border:'none', borderRadius:'8px',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnPrint:  { padding:'8px 18px', background:'linear-gradient(135deg,#0d47a1,#1565c0)',
               color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnAllReport: { padding:'8px 18px', background:'linear-gradient(135deg,#00695c,#00897b)',
               color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  btnAuto:   { padding:'8px 18px', background:'linear-gradient(135deg,#8d6e00,#C8A84B)',
              color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
              fontFamily:'inherit', fontSize:'13px', fontWeight:'700', whiteSpace:'nowrap' },
  autoMenuOverlay: { position:'fixed', inset:0, zIndex:1200, background:'transparent' },
  autoMenu:  { position:'absolute', top:'calc(100% + 6px)', left:0, zIndex:1201,
              background:'#fff', borderRadius:'10px', boxShadow:'0 10px 30px rgba(0,0,0,0.25)',
              border:'1px solid #e0e0e0', width:'250px', overflow:'hidden' },
  autoMenuTitle: { padding:'8px 12px', background:'#1a2f50', color:'#C8A84B',
              fontSize:'11px', fontWeight:'700', textAlign:'center' },
  autoMenuItem:  { display:'flex', alignItems:'center', justifyContent:'space-between',
              width:'100%', padding:'9px 12px', border:'none', borderBottom:'1px solid #f0f0f0',
              fontFamily:'inherit', fontSize:'12.5px', fontWeight:'600', color:'#1a2f50',
              textAlign:'right' },
  autoMenuSoon:  { fontSize:'9.5px', fontWeight:'700', color:'#999', background:'#eee',
              borderRadius:'10px', padding:'2px 7px' },
  btnRefresh:{ padding:'8px 14px', background:'linear-gradient(135deg,#37474f,#455a64)',
               color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
               fontFamily:'inherit', fontSize:'13px', alignSelf:'flex-end' },
  countBadge:{ padding:'6px 12px', background:'#1a2f50', color:'#C8A84B',
               borderRadius:'20px', fontSize:'12px', fontWeight:'700',
               whiteSpace:'nowrap', alignSelf:'flex-end' },
  errBox:    { background:'#fff3f3', border:'1px solid #ffcdd2', borderRadius:'8px',
               padding:'10px 14px', color:'#c62828', marginBottom:'10px', fontSize:'13px' },

  tableWrap: { overflowX:'auto', overflowY:'auto', borderRadius:'12px',
               boxShadow:'0 2px 12px rgba(0,0,0,0.1)', background:'#fff',
               flex:1, minHeight:0 },
  table:     { width:'100%', borderCollapse:'collapse' },
  th:        { padding:'9px 10px', fontWeight:'700', textAlign:'center',
               whiteSpace:'nowrap', borderLeft:'1px solid rgba(255,255,255,0.1)',
               fontFamily:'inherit', fontSize:'12px', position:'sticky', top:0 },
  td:        { padding:'7px 9px', borderBottom:'1px solid #f0f0f0',
               textAlign:'center', fontSize:'12px', whiteSpace:'nowrap',
               overflow:'hidden', textOverflow:'ellipsis' },
  empty:     { textAlign:'center', padding:'48px', color:'#999', fontSize:'14px' },

  overlay:   { position:'fixed', inset:0, background:'rgba(0,0,0,0.55)', zIndex:1000,
               display:'flex', alignItems:'center', justifyContent:'center', padding:'16px' },
  modal:     { background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'640px',
               maxHeight:'90vh', display:'flex', flexDirection:'column',
               boxShadow:'0 20px 60px rgba(0,0,0,0.4)' },
  mHeader:   { display:'flex', justifyContent:'space-between', alignItems:'center',
               padding:'16px 20px', background:'linear-gradient(135deg,#0a1628,#1a2f50)',
               borderRadius:'16px 16px 0 0' },
  mTitle:    { fontSize:'15px', fontWeight:'700', color:'#fff' },
  closeBtn:  { background:'rgba(255,255,255,0.15)', border:'1px solid rgba(255,255,255,0.3)',
               color:'#fff', width:'30px', height:'30px', borderRadius:'50%',
               cursor:'pointer', fontSize:'13px', display:'flex',
               alignItems:'center', justifyContent:'center' },
  mBody:     { overflowY:'auto', flex:1, padding:'18px' },
  mFooter:   { display:'flex', justifyContent:'flex-end', gap:'10px', padding:'12px 18px',
               borderTop:'1px solid #f0f2f7', background:'#f8f9fa',
               borderRadius:'0 0 16px 16px' },
  row:       { display:'flex', gap:'12px', marginBottom:'12px', flexWrap:'wrap' },
  divider:   { height:'1px', background:'#f0f2f7', margin:'10px 0' },
  btnCancel: { padding:'8px 18px', background:'#e0e0e0', color:'#333', border:'none',
               borderRadius:'8px', cursor:'pointer', fontFamily:'inherit', fontSize:'13px' },
  btnSave:   { padding:'8px 22px', background:'linear-gradient(135deg,#1b5e20,#2e7d32)',
               color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer',
               fontFamily:'inherit', fontSize:'13px', fontWeight:'700' },
  toast:     { position:'fixed', bottom:'24px', right:'24px', background:'#1b5e20',
               color:'#fff', padding:'12px 24px', borderRadius:'10px', fontSize:'14px',
               fontWeight:'600', zIndex:2000, boxShadow:'0 4px 16px rgba(0,0,0,0.25)' },
};